import { AudioDeviceFactType } from '@shared/enums/live';
import type { AudioDeviceFact } from '@shared/models/websocket';

export const AUDIO_ONLY_PREFIX = 'audio-only:';

export interface AudioDeviceFactReport {
  liveCode: string;
  fact: AudioDeviceFact;
}

/** Only the equipment reports, so facts are not duplicated per viewer. No sequence here:
 * the websocket assigns it, so a client can never forge ordering. */
export function buildAudioDeviceFact(input: {
  connectionData: string | undefined;
  connectionId: string;
  type: AudioDeviceFactType;
  isMuted?: boolean;
  liveCode: string | undefined;
  isEquipment: boolean;
}): AudioDeviceFactReport | null {
  if (!input.isEquipment || !input.liveCode) return null;

  const deviceId = readAudioDeviceId(input.connectionData);
  if (!deviceId) return null;

  return {
    liveCode: input.liveCode,
    fact: {
      deviceId,
      type: input.type,
      connectionId: input.connectionId,
      ...(input.isMuted !== undefined ? { isMuted: input.isMuted } : {}),
    },
  };
}

export function readAudioDeviceId(connectionData: string | undefined): string | null {
  if (!connectionData) return null;
  try {
    const externalId = (JSON.parse(connectionData) as { externalId?: unknown }).externalId;
    if (typeof externalId !== 'string' || !externalId.startsWith(AUDIO_ONLY_PREFIX)) return null;
    const deviceId = externalId.slice(AUDIO_ONLY_PREFIX.length);
    return deviceId.length > 0 ? deviceId : null;
  } catch {
    // Regular clients may set any string as connection data.
    return null;
  }
}
